<template>
  <div>
    <!-- <h5 class="title" style="">
            {{ lodash.upperCase($t('Filter')) }}
        </h5> -->
    <b-card no-body class="border-0">
      <b-card-body style="">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title" @click="filterVisible = !filterVisible" role="button">
            FILTER
            <svg
              :style="
                `${!filterVisible ? 'transform: rotate(180deg)' : 'transform: rotate(0deg)'}; transition: all .2s`
              "
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.99996 0.666626C13.595 0.666626 17.3333 4.40496 17.3333 8.99996C17.3333 13.595 13.595 17.3333 8.99996 17.3333C4.40496 17.3333 0.666626 13.595 0.666626 8.99996C0.666626 4.40496 4.40496 0.666626 8.99996 0.666626ZM8.99996 1.91663C5.09413 1.91663 1.91663 5.09413 1.91663 8.99996C1.91663 12.9058 5.09413 16.0833 8.99996 16.0833C12.9058 16.0833 16.0833 12.9058 16.0833 8.99996C16.0833 5.09413 12.9058 1.91663 8.99996 1.91663ZM9.44304 6.85529L12.3355 9.76113C12.5789 10.0061 12.578 10.4011 12.3339 10.6445C12.2122 10.7661 12.0522 10.827 11.893 10.827C11.733 10.827 11.5722 10.7661 11.4505 10.6428L8.99971 8.18196L6.55054 10.6428C6.30721 10.8878 5.91138 10.8878 5.66638 10.6445C5.42221 10.4011 5.42054 10.0061 5.66471 9.76113L8.55721 6.85529C8.79138 6.61946 9.20804 6.61946 9.44304 6.85529Z"
                fill="#454646"
              />
            </svg>
          </div>
          <div class="title" @click="resetFilter" role="button">RESET</div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <!-- <div class="label-filter">Jenis Servis</div> -->
            <!-- <component :is="resolveComponent('ticket.customer_type').input_component" v-model="resolveComponent('ticket.customer_type').value"/> -->
            <filter-item :filter-column="resolveComponent('ticket.customer_type')"></filter-item>
          </div>
          <div class="col-md-3">
            <!-- <div class="label-filter">Tgl Nota Panen</div>
                        <component :is="resolveComponent('ordered_at__between').input_component" v-model="resolveComponent('ordered_at__between').value"/> -->
            <filter-item :filter-column="resolveComponent('ordered_at__between')"></filter-item>
          </div>
          <div class="col-md-3">
            <!-- <div class="label-filter">Pembayaran Pembelian</div>
                        <component :is="resolveComponent('payment_status').input_component" v-model="resolveComponent('payment_status').value"/> -->
            <filter-item :filter-column="resolveComponent('odoo_purchase_order_state__in')"></filter-item>
          </div>
          <div class="col-md-3">
            <!-- <div class="label-filter">Pembayaran Pembelian</div>
                        <component :is="resolveComponent('payment_status').input_component" v-model="resolveComponent('payment_status').value"/> -->
            <filter-item :filter-column="resolveComponent('odoo_purchase_order_invoice_status__in')"></filter-item>
          </div>

        </div>
        <b-collapse id="filter-collapse" class="mt-2" v-model="filterVisible">
          <div class="row">
            <div class="col-md-3">
              <!-- <div class="label-filter">Layanan Produk</div>
                          <component :is="resolveComponent('shrimp_id__in').input_component" v-model="resolveComponent('shrimp_id__in').value"/> -->
              <filter-item :filter-column="resolveComponent('product_id__in')"></filter-item>
            </div>
            <div class="col-md-3">
              <!-- <div class="label-filter">ID Nota Panen</div>
                            <component :is="resolveComponent('id__in').input_component" v-model="resolveComponent('id__in').value"/> -->
              <filter-item :filter-column="resolveComponent('id__in')"></filter-item>
            </div>
            <div class="col-md-6">
              <!-- <div class="label-filter">Mitra</div>
                            <component :is="resolveComponent('customer_id__in').input_component" v-model="resolveComponent('customer_id__in').value"/> -->
              <filter-item :filter-column="resolveComponent('customer_id__in')"></filter-item>
            </div>
          </div>
        </b-collapse>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ModelFilter from "@/components/model-filter-v4";

export default {
  extends: ModelFilter,
  data() {
    return {
      filterVisible: false
    };
  }
};
</script>

<style scoped>
.multiselect__content-wrapper {
  height: 1000px !important;
}

.label-filter {
  font-weight: 500;
  font-size: 14px;
  color: #6c7589;
  margin-bottom: 5px;
}
</style>
